import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../.../../../http-common";


export const getDailyCollection = (postObj) => {
    return apiClient.post(`/reports/rptCollectionReport`, postObj, {
        headers: authHeader(),
        responseType: "blob"  
    })
}